import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { decrypt_cookie } from "../../../data/allfunction";
function logGet() {
  let logdata = Cookies.get("log");
  if (logdata === undefined) {
    return {
      user: "",
      name: "",
      log: false,
      level: "",
      user_id: "",
      retoken: "",
      token: "",
      agent_Code: "",
      agent_id: "",
      agent_c: "",
      agent_unlock_a: "",
      agent_scp_p: "",
      agent_conf: {},
    };
  } else {
    return JSON.parse(decrypt_cookie(logdata));
  }
}

export const userSlice = createSlice({
  name: "user",
  initialState: logGet(),
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.name = action.payload.name;
      state.log = action.payload.log;
      state.level = action.payload.level;
      state.user_id = action.payload.user_id;
      state.retoken = action.payload.retoken;
      state.token = action.payload.token;
      state.agent_Code = action.payload.agent_Code;
      state.agent_id = action.payload.agent_id;

      state.agent_c = action.payload.agent_c;
      state.agent_unlock_a = action.payload.agent_unlock_a;
      state.agent_scp_p = action.payload.agent_scp_p;
      state.agent_conf = action.payload.agent_conf;
    },
    delUser: (state) => {
      Cookies.remove("log");
      state.user = "";
      state.name = "";
      state.log = false;
      state.level = "";
      state.user_id = "";
      state.retoken = "";
      state.token = "";
      state.agent_Code = "";
      state.agent_id = "";

      state.agent_c = "";
      state.agent_unlock_a = "";
      state.agent_scp_p = "";
      state.agent_conf = "";
    },
    Useralert: (state) => {
      console.log("state");
    },
  },
});

export const { delUser, setUser, Useralert } = userSlice.actions;

export default userSlice.reducer;
